import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import './Footer.style.css';

export const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const quickLinks = [
    { label: t('home'),      to: '/' },
    { label: t('buyCar'),    to: '/featured-cars' },
    { label: t('sellCar'),   to: '/AddCars' },
    { label: t('mySpace'),   to: '/my-cars' },
    { label: t('favoritesNav'), to: '/favorites' },
  ];

  const categories = [
    t('footerCategories.citadines'), t('footerCategories.berlines'),
    t('footerCategories.suv4x4'), t('footerCategories.coupes'),
    t('footerCategories.monospaces'), t('footerCategories.utilitaires'),
    t('footerCategories.cabriolets'), t('footerCategories.electriques'),
  ];

  const socials = [
    { icon: <FacebookIcon />, href: '#', label: 'Facebook' },
    { icon: <InstagramIcon />, href: '#', label: 'Instagram' },
    { icon: <XIcon />,        href: '#', label: 'X' },
    { icon: <YouTubeIcon />,  href: '#', label: 'YouTube' },
  ];

  return (
    <footer className="ft">
      {/* ── Top strip ───────────────────────────────────────── */}
      <div className="ft-top">
        <div className="ft-inner">
          <span>{t('footerTagline')}</span>
          <Link to="/featured-cars" className="ft-top__btn">{t('footerBrowseCta')} →</Link>
        </div>
      </div>

      {/* ── Main grid ───────────────────────────────────────── */}
      <div className="ft-main">
        <div className="ft-inner ft-grid">

          {/* Col 1 – Brand */}
          <div className="ft-col ft-col--brand">
            <div className="ft-logo">
              <DirectionsCarIcon className="ft-logo__icon" />
              <span>Carix</span>
            </div>
            <p className="ft-desc">
              {t('footerDesc')}
            </p>
            <div className="ft-socials">
              {socials.map(s => (
                <a key={s.label} href={s.href} aria-label={s.label} className="ft-social-btn">
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 – Navigation */}
          <div className="ft-col">
            <h4 className="ft-col__title">{t('navigation')}</h4>
            <ul className="ft-list">
              {quickLinks.map(l => (
                <li key={l.to}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 – Catégories */}
          <div className="ft-col">
            <h4 className="ft-col__title">{t('categoriesTitle')}</h4>
            <ul className="ft-list">
              {categories.map(c => (
                <li key={c}>
                  <Link to="/featured-cars">{c}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 – Contact */}
          <div className="ft-col">
            <h4 className="ft-col__title">{t('contactTitle')}</h4>
            <ul className="ft-contact-list">
              <li>
                <EmailIcon className="ft-contact-icon" />
                <a href="mailto:contact@carix.com">contact@carix.com</a>
              </li>
              <li>
                <PhoneIcon className="ft-contact-icon" />
                <a href="tel:+212695387185">+212 696683383</a>
              </li>
              <li>
                <LocationOnIcon className="ft-contact-icon" />
                <span>{t('companyLocation')}</span>
              </li>
            </ul>

            {/* <div className="ft-stores">
              <a href="#" className="ft-store-btn">
                <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" />
              </a>
              <a href="#" className="ft-store-btn">
                <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="App Store" />
              </a>
            </div> */}
          </div>
        </div>
      </div>

      {/* ── Bottom bar ──────────────────────────────────────── */}
      <div className="ft-bottom">
        <div className="ft-inner ft-bottom__row">
          <span>{t('footerCopyright', { year })}</span>
          <div className="ft-legal">
            <a href="#">{t('termsOfService')}</a>
            <a href="#">{t('privacyPolicy')}</a>
            <a href="#">{t('cookies')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
